

/**
 * Это очень важный файл, здесь мы тоже работаем, например модифицируем enum'ы и тд.
 *
 * Здесь происходит вторая регистрация проектов и контекстов.
 *
 * Никакого хардкода!!
 */

import { isServer } from 'shared/constants/isServer';
import { bString } from './core';
import { ApplicationShared } from './core';
import { DEZIIIGN_CONTEXTS } from 'shared/constants/enginePaths';

export enum AppName {
  deziiign = 'deziiign',
  geograffee = 'geograffee',
  designlab = 'labolatory',
  gallllery = 'gallllery',
  mediiia = 'mediiia',
  competition = 'competition',
  hsedesign = 'hsedesign'
}

export enum AppContext {
  education = 'education',
  main = 'main',
  design = 'design',
  art = 'art',
  fashion = 'fashion',
  events = 'events',
  space = 'space',
  urban = 'urban',
  places = 'places',
}

export enum AppMode {
  production = 'production',
  develop = 'develop',
  staging = 'staging',
}

const AppContextTitleMap: Record<string, string> = {
  education: 'education',
  main: 'deziiign',
  design: 'design',
  art: 'art',
  fashion: 'fashion',
  events: 'events',
  space: 'space',
  media: 'creative',
  places: 'places',
  creative: 'creative',
};

/**
 * Конфигурация стартера
 */
export const StarterSettings = {
  // Стартовый файл
  appStarterFile: 'app.tsx',

  // Стартовый заголовок
  appDefaultTitle: 'Burgundy Engine',
};

/**
 * Получение контекста из названия мини-приложения
 * @param appName
 */
export const getContextFromAppName = (appName: string): string => {
  const parts = appName.split('/');

  const contextName = parts.length === 1 || !parts[1] || bString.isEmpty(parts[1]) ? 'main' : parts[1];

  if (contextName === 'hsealumni') {
    return 'education'
  }

  return contextName;
};

export const getAppNameFromAppString = (appName: string): string => appName.split('/')[0];

export const getCurrentContextName = (): string => getContextFromAppName(ApplicationShared.application);

export const getCurrentContextTitle = (): string => AppContextTitleMap[getCurrentContextName()] || '';

/**
 * Возвращает название  мини-приложения ЗАПУЩЕННОГО В ТЕКУЩИЙ МОМЕНТ
 */
export const getCurrentAppName = (): string => getAppNameFromAppString(ApplicationShared.application);

// const safeWindow = isServer ? {
//     location: {
//         pathname: '/',
//     }
// } : window;

export const buildAppTester = (getApplication: () => string) => {
  const getContextName = () => getContextFromAppName(getApplication());
  const getAppName = () => getAppNameFromAppString(getApplication());
  const isContext = (c?: string): boolean => getContextName() === c;
  const isApp = (a?: string): boolean => getAppName() === a;

  return {
    isContext,
    isApp,

    // Тестирование приложений
    isDeziiign: (): boolean => isApp('deziiign'),
    isGallllery: (): boolean => isApp('gallllery'),
    isMediiiaMain: (): boolean => isApp('deziiign') && isContext('mediiia'),
    isMediiiaStories: (): boolean => isApp('deziiign') && isContext('storiesmediiia'),
    isMediiiaNature: (): boolean => isApp('deziiign') && isContext('naturemediiia'),
    isMediiiaSport: (): boolean => isApp('deziiign') && isContext('sportmediiia'),
    isMediiiaProf: (): boolean => isApp('deziiign') && isContext('profmediiia'),
    isMediiiaPhoto: (): boolean => isApp('deziiign') && isContext('photomediiia'),
    isMediiiaCine: (): boolean => isApp('deziiign') && isContext('cinemediiia'),
    isMediiiaAi: (): boolean => isApp('deziiign') && isContext('aimediiia'),
    isMediiiaArt: (): boolean => isApp('deziiign') && isContext('artmediiia'),
    isMediiiaUrban: (): boolean => isApp('deziiign') && isContext('urbanmediiia'),
    isMediiiaFood: (): boolean => isApp('deziiign') && isContext('foodmediiia'),
    isMediiiaAuto: (): boolean => isApp('deziiign') && isContext('automediiia'),
    isMediiiaConcept: (): boolean => isApp('deziiign') && isContext('conceptmediiia'),  
    isDesignMediiia: (): boolean => isApp('deziiign') && isContext('designmediiia'),
    isHistoryMediiia: (): boolean => isApp('deziiign') && isContext('historymediiia'),
    isMusicMediiia: (): boolean => isApp('deziiign') && isContext('musicmediiia'),
    isEventMediiia: (): boolean => isApp('deziiign') && isContext('eventmediiia'),
    isArtMediiia: (): boolean => isApp('deziiign') && isContext('artmediiia'),
    isAstroMediiia: (): boolean => isApp('deziiign') && isContext('astromediiia'),
    isGeograffee: (): boolean => isApp('geograffee'),
    isAgeytomesh: (): boolean => isContext('ageytomesh'),
    isCompetition: (): boolean => isApp('competition'),
    // Контексты
    isMainContext: (): boolean => isContext('main'),
    isLabDeziiign: (): boolean => isApp('deziiign') && isContext('lab'),
    isHSESpaceSegmants: (): boolean => isContext('s-architect')
      || isContext('s-biology')
      || isContext('s-oriental')
      || isContext('s-geography')
      || isContext('s-history')
      || isContext('s-arthistory')
      || isContext('s-cinema')
      || isContext('s-cognitive')
      || isContext('s-culturology')
      || isContext('s-mathematics')
      || isContext('s-media')
      || isContext('s-fashion')
      || isContext('s-music')
      || isContext('s-production')
      || isContext('s-pro')
      || isContext('s-hsetto')
      || isContext('s-psychology')
      || isContext('s-public-administration')
      || isContext('s-physics')
      || isContext('s-chemistry')
      || isContext('s-economy')
      || isContext('hsespacecreative')
      || isContext('hsespacefilm')
      || isContext('s-urban-development')
      || isContext('s-computer-science-and-engineering')
      || isContext('s-international-relations')
      || isContext('s-management')
      || isContext('s-political-science')
      || isContext('s-advertising-and-pr')
      || isContext('s-software-engineering')
      || isContext('s-sociology')
      || isContext('s-philology')
      || isContext('s-philosophy')
      || isContext('s-jurisprudence')
      || isContext('hsecreativehub'),
    // Контексты Deziiign
    isDeziiignMain: (): boolean => isApp('deziiign') && isContext('main'),
    isDeziiignContext: (): boolean => DEZIIIGN_CONTEXTS.includes(getApplication()),
    isDeziiignEssential: (): boolean => isApp('deziiign') && !(
      (isApp('deziiign') && (isContext('hsedesign')
        || isContext('prohse')
        || isContext('lmshse')
        || isContext('hsehh')
        || isContext('hsecolors')
        || isContext('hsecreative')
        || isContext('damuseum')
        || isContext('hsestart')
        || isContext('exams')
        || isContext('hsespace')
        || (isContext('s-architect')
          || isContext('s-biology')
          || isContext('s-oriental')
          || isContext('s-geography')
          || isContext('s-history')
          || isContext('s-arthistory')
          || isContext('s-cinema')
          || isContext('s-cognitive')
          || isContext('s-culturology')
          || isContext('s-mathematics')
          || isContext('s-media')
          || isContext('s-fashion')
          || isContext('s-music')
          || isContext('s-production')
          || isContext('s-pro')
          || isContext('s-hsetto')
          || isContext('s-psychology')
          || isContext('s-public-administration')
          || isContext('s-physics')
          || isContext('s-chemistry')
          || isContext('s-economy')
          || isContext('hsespacecreative')
          || isContext('hsespacefilm')
          || isContext('s-urban-development')
          || isContext('s-computer-science-and-engineering')
          || isContext('s-international-relations')
          || isContext('s-management')
          || isContext('s-political-science')
          || isContext('s-advertising-and-pr')
          || isContext('s-software-engineering')
          || isContext('s-sociology')
          || isContext('s-philology')
          || isContext('s-philosophy')
          || isContext('s-jurisprudence')
          || isContext('hsecreativehub')
        )
      )) || (isApp('deziiign') && isContext('onlines')) || (isApp('deziiign') && isContext('school'))
    ),
    isHSEDesign: (): boolean => isApp('deziiign') && (isContext('hsedesign')
      || isContext('prohse')
      || isContext('lmshse')
      || isContext('hsehh')
      || isContext('hsecolors')
      || isContext('hsecreative')
      || isContext('damuseum')
      || isContext('hsestart')
      || isContext('exams')
      || isContext('hsespace')
      || (
        isContext('s-architect')
        || isContext('s-biology')
        || isContext('s-oriental')
        || isContext('s-geography')
        || isContext('s-history')
        || isContext('s-arthistory')
        || isContext('s-cinema')
        || isContext('s-cognitive')
        || isContext('s-culturology')
        || isContext('s-mathematics')
        || isContext('s-media')
        || isContext('s-fashion')
        || isContext('s-music')
        || isContext('s-production')
        || isContext('s-pro')
        || isContext('s-hsetto')
        || isContext('s-psychology')
        || isContext('s-public-administration')
        || isContext('s-physics')
        || isContext('s-chemistry')
        || isContext('s-economy')
        || isContext('hsespacecreative')
        || isContext('hsespacefilm')
        || isContext('s-urban-development')
        || isContext('s-computer-science-and-engineering')
        || isContext('s-international-relations')
        || isContext('s-management')
        || isContext('s-political-science')
        || isContext('s-advertising-and-pr')
        || isContext('s-software-engineering')
        || isContext('s-sociology')
        || isContext('s-philology')
        || isContext('s-philosophy')
        || isContext('s-jurisprudence')
        || isContext('hsecreativehub')
      )
    ),
    isOnlineHSEDesign: (): boolean => isApp('deziiign') && isContext('online'),
    isOnlines: (): boolean => isApp('deziiign') && isContext('onlines'),
    isMediiia: (): boolean => isApp('deziiign') && (isContext('mediiia')
      || isContext('lmsmediiia')
      || isContext('namesmediiia')
      || isContext('sciencemediiia')
      || isContext('iqmedia')
      || isContext('historymediiia')
      || isContext('transfermediiia')
      || isContext('creativemediiia')
      || isContext('sportmediiia')
      || isContext('profmediiia')
      || isContext('photomediiia')
      || isContext('cinemediiia')
      || isContext('aimediiia')
      || isContext('historymediiia')
      || isContext('sportmediiia')
      || isContext('eventmediiia')
      || isContext('musicmediiia')
      || isContext('storiesmediiia')
      || isContext('naturemediiia')
      || isContext('designmediiia')
      || isContext('artmediiia')
      || isContext('fashionmediiia')
      || isContext('foodmediiia')
      || isContext('automediiia')
      || isContext('iqmediiia')
      || isContext('booksmediiia')
      || isContext('conceptmediiia')
    ),
    isCGRAVE: (): boolean => isContext('cgrave'),
    isGreenAward: (): boolean => isContext('greenaward'),
    isAdcrDafesNet: (): boolean => isContext('adcrdafesnet'),
    isContinuumSite: (): boolean => isContext('continuumsite'),
    isGameDeziiign: (): boolean => isContext('game'),
    isIqMediiia: (): boolean => isContext('iqmedia'),
    isHseHH: (): boolean => isContext('hsehh'),
    isHseColors: (): boolean => isContext('hsecolors'),
    isHseAnimation: (): boolean => isContext('hseanimation'),
    isHseSpace: (): boolean => isApp('deziiign') && (isContext('hsespace') 
      || (
        isContext('s-architect')
        || isContext('s-biology')
        || isContext('s-oriental')
        || isContext('s-geography')
        || isContext('s-history')
        || isContext('s-arthistory')
        || isContext('s-cinema')
        || isContext('s-cognitive')
        || isContext('s-culturology')
        || isContext('s-mathematics')
        || isContext('s-media')
        || isContext('s-fashion')
        || isContext('s-music')
        || isContext('s-production')
        || isContext('s-pro')
        || isContext('s-hsetto')
        || isContext('s-psychology')
        || isContext('s-public-administration')
        || isContext('s-physics')
        || isContext('s-chemistry')
        || isContext('s-economy')
        || isContext('hsespacecreative')
        || isContext('hsespacefilm')
        || isContext('s-urban-development')
        || isContext('s-computer-science-and-engineering')
        || isContext('s-international-relations')
        || isContext('s-management')
        || isContext('s-political-science')
        || isContext('s-advertising-and-pr')
        || isContext('s-software-engineering')
        || isContext('s-sociology')
        || isContext('s-philology')
        || isContext('s-philosophy')
        || isContext('s-jurisprudence')
        || isContext('hsecreativehub')
      )
    ),
    isCreativeSpace: (): boolean => isApp('deziiign') && isContext('hsespacecreative'),
    isLectureMediiia: (): boolean => isApp('deziiign') && isContext('lmsmediiia'),
    isNamesMediiia: (): boolean => isApp('deziiign') && isContext('namesmediiia'),
    isScienceMediiia: (): boolean => isApp('deziiign') && isContext('sciencemediiia'),
    isSchool: (): boolean => isApp('deziiign') && isContext('school'),
    isGeoMain: (): boolean => isApp('geograffee') && isContext('main'),
    isGeoDafes: (): boolean => isApp('geograffee') && isContext('dafes'),
    isPortfolio365: (): boolean => isApp('deziiign') && isContext('awards'),
    isKiiidsArt: (): boolean => isApp('deziiign') && isContext('kiiids'),
    isAcademy: (): boolean => isApp('geograffee') && isContext('academy'),
    isCompetitionEducation: (): boolean => isContext('competition'),
    isResearch: (): boolean => isApp('deziiign') && isContext('research'),
    isBooksDeziiign: (): boolean => (isApp('deziiign') && isContext('books')),
    isBooksMain: (): boolean => (isApp('deziiign') && isContext('books')) || isContext('booksgallllery'),
    isBooksGallllery: (): boolean => isContext('booksgallllery'),
    isBooksMediiia: (): boolean => isContext('booksmediiia'),
    isBooks: (): boolean => (
      ((isApp('deziiign') && isContext('books')) || isContext('booksgallllery'))
      || window.location.pathname.startsWith('/books')
      || window.location.pathname.startsWith('/hsebooks')
    ),
    isBrnd: (): boolean => isApp('deziiign') && isContext('brnd'),

    // Контексты Gallllery
    isGalllleryMain: (): boolean => isApp('gallllery') && isContext('main'),
    isMediaclub: (): boolean => isApp('gallllery') && isContext('mediaclub'),
    isSuperPuper: (): boolean => isApp('deziiign') && isContext('superpuper'),
    isFashionDeziiign: (): boolean => isApp('deziiign') && isContext('fashion'),
    isProDeziiign: (): boolean => isApp('deziiign') && ( isContext('pro') || isContext('prohse') || isContext('lmsmediiia')),
    isProHSE: (): boolean => isApp('deziiign') && isContext('prohse'),
    isLMSHSE: (): boolean => isApp('deziiign') && isContext('lmshse'),
    isLMSHSECreative: (): boolean => isApp('deziiign') && isContext('lmshsecreative'),
    isExamHSE: (): boolean => isApp('deziiign') && isContext('exams'),
    isDvaDesign: (): boolean => isApp('deziiign') && isContext('dvadesign'),
    isGalllleryArt: (): boolean => isApp('deziiign') && isContext('galllleryart'),
    isDaMuseum: (): boolean => isApp('deziiign') && isContext('damuseum'),
    isCreativeHSE: (): boolean => isApp('deziiign') && isContext('hsecreative'),
    isStartHSE: (): boolean => isApp('deziiign') && isContext('hsestart'),
    isLPUDesign: (): boolean => isApp('deziiign') && isContext('lpudesign'),
    isMonaLisaTravels: (): boolean => isApp('deziiign') && isContext('monalisatravels'),
  };
};

export type AppTesterType = ReturnType<typeof buildAppTester>;

export const AppTester: AppTesterType = buildAppTester(() => ApplicationShared.application);

export const isAnyOf = (): Record<string, boolean> => {
  return Object.entries(AppTester).slice(2).reduce((res, [key, callback]) => {
    return {
      ...res,
      [key]: callback(),
    }
  }, {} as Record<string, boolean>)
}


/**
 * Это очень важный файл, здесь мы тоже работаем, например модифицируем enum'ы и тд.
 *
 * Здесь происходит вторая регистрация проектов и контекстов.
 *
 * Никакого хардкода!!
 */

import { isServer } from 'shared/constants/isServer';
import { bString } from './core';
import { ApplicationShared } from './core';
import { DEZIIIGN_CONTEXTS } from 'shared/constants/enginePaths';

export enum AppName {
  deziiign = 'deziiign',
  geograffee = 'geograffee',
  designlab = 'labolatory',
  gallllery = 'gallllery',
  mediiia = 'mediiia',
  competition = 'competition',
  hsedesign = 'hsedesign'
}

export enum AppContext {
  education = 'education',
  main = 'main',
  design = 'design',
  art = 'art',
  fashion = 'fashion',
  events = 'events',
  space = 'space',
  urban = 'urban',
  places = 'places',
}

export enum AppMode {
  production = 'production',
  develop = 'develop',
  staging = 'staging',
}

const AppContextTitleMap: Record<string, string> = {
  education: 'education',
  main: 'deziiign',
  design: 'design',
  art: 'art',
  fashion: 'fashion',
  events: 'events',
  space: 'space',
  media: 'creative',
  places: 'places',
  creative: 'creative',
};

/**
 * Конфигурация стартера
 */
export const StarterSettings = {
  // Стартовый файл
  appStarterFile: 'app.tsx',

  // Стартовый заголовок
  appDefaultTitle: 'Burgundy Engine',
};

/**
 * Получение контекста из названия мини-приложения
 * @param appName
 */
export const getContextFromAppName = (appName: string): string => {
  const parts = appName.split('/');

  const contextName = parts.length === 1 || !parts[1] || bString.isEmpty(parts[1]) ? 'main' : parts[1];

  if (contextName === 'hsealumni') {
    return 'education'
  }

  return contextName;
};

export const getAppNameFromAppString = (appName: string): string => appName.split('/')[0];

export const getCurrentContextName = (): string => getContextFromAppName(ApplicationShared.application);

export const getCurrentContextTitle = (): string => AppContextTitleMap[getCurrentContextName()] || '';

/**
 * Возвращает название  мини-приложения ЗАПУЩЕННОГО В ТЕКУЩИЙ МОМЕНТ
 */
export const getCurrentAppName = (): string => getAppNameFromAppString(ApplicationShared.application);

// const safeWindow = isServer ? {
//     location: {
//         pathname: '/',
//     }
// } : window;

export const buildAppTester = (getApplication: () => string) => {
  const getContextName = () => getContextFromAppName(getApplication());
  const getAppName = () => getAppNameFromAppString(getApplication());
  const isContext = (c?: string): boolean => getContextName() === c;
  const isApp = (a?: string): boolean => getAppName() === a;

  return {
    isContext,
    isApp,

    // Тестирование приложений
    isDeziiign: (): boolean => isApp('deziiign'),
    isGallllery: (): boolean => isApp('gallllery'),
    isMediiiaMain: (): boolean => isApp('deziiign') && isContext('mediiia'),
    isMediiiaStories: (): boolean => isApp('deziiign') && isContext('storiesmediiia'),
    isMediiiaNature: (): boolean => isApp('deziiign') && isContext('naturemediiia'),
    isMediiiaSport: (): boolean => isApp('deziiign') && isContext('sportmediiia'),
    isMediiiaProf: (): boolean => isApp('deziiign') && isContext('profmediiia'),
    isMediiiaPhoto: (): boolean => isApp('deziiign') && isContext('photomediiia'),
    isMediiiaCine: (): boolean => isApp('deziiign') && isContext('cinemediiia'),
    isMediiiaAi: (): boolean => isApp('deziiign') && isContext('aimediiia'),
    isMediiiaArt: (): boolean => isApp('deziiign') && isContext('artmediiia'),
    isMediiiaUrban: (): boolean => isApp('deziiign') && isContext('urbanmediiia'),
    isMediiiaFood: (): boolean => isApp('deziiign') && isContext('foodmediiia'),
    isMediiiaAuto: (): boolean => isApp('deziiign') && isContext('automediiia'),
    isMediiiaConcept: (): boolean => isApp('deziiign') && isContext('conceptmediiia'),  
    isDesignMediiia: (): boolean => isApp('deziiign') && isContext('designmediiia'),
    isHistoryMediiia: (): boolean => isApp('deziiign') && isContext('historymediiia'),
    isMusicMediiia: (): boolean => isApp('deziiign') && isContext('musicmediiia'),
    isEventMediiia: (): boolean => isApp('deziiign') && isContext('eventmediiia'),
    isArtMediiia: (): boolean => isApp('deziiign') && isContext('artmediiia'),
    isAstroMediiia: (): boolean => isApp('deziiign') && isContext('astromediiia'),
    isGeograffee: (): boolean => isApp('geograffee'),
    isAgeytomesh: (): boolean => isContext('ageytomesh'),
    isCompetition: (): boolean => isApp('competition'),
    // Контексты
    isMainContext: (): boolean => isContext('main'),
    isLabDeziiign: (): boolean => isApp('deziiign') && isContext('lab'),
    isHSESpaceSegmants: (): boolean => isContext('s-architect')
      || isContext('s-biology')
      || isContext('s-oriental')
      || isContext('s-geography')
      || isContext('s-history')
      || isContext('s-arthistory')
      || isContext('s-cinema')
      || isContext('s-cognitive')
      || isContext('s-culturology')
      || isContext('s-mathematics')
      || isContext('s-media')
      || isContext('s-fashion')
      || isContext('s-music')
      || isContext('s-production')
      || isContext('s-pro')
      || isContext('s-hsetto')
      || isContext('s-psychology')
      || isContext('s-public-administration')
      || isContext('s-physics')
      || isContext('s-chemistry')
      || isContext('s-economy')
      || isContext('hsespacecreative')
      || isContext('hsespacefilm')
      || isContext('s-urban-development')
      || isContext('s-computer-science-and-engineering')
      || isContext('s-international-relations')
      || isContext('s-management')
      || isContext('s-political-science')
      || isContext('s-advertising-and-pr')
      || isContext('s-software-engineering')
      || isContext('s-sociology')
      || isContext('s-philology')
      || isContext('s-philosophy')
      || isContext('s-jurisprudence')
      || isContext('hsecreativehub'),
    // Контексты Deziiign
    isDeziiignMain: (): boolean => isApp('deziiign') && isContext('main'),
    isDeziiignContext: (): boolean => DEZIIIGN_CONTEXTS.includes(getApplication()),
    isDeziiignEssential: (): boolean => isApp('deziiign') && !(
      (isApp('deziiign') && (isContext('hsedesign')
        || isContext('prohse')
        || isContext('lmshse')
        || isContext('hsehh')
        || isContext('hsecolors')
        || isContext('hsecreative')
        || isContext('damuseum')
        || isContext('hsestart')
        || isContext('exams')
        || isContext('hsespace')
        || (isContext('s-architect')
          || isContext('s-biology')
          || isContext('s-oriental')
          || isContext('s-geography')
          || isContext('s-history')
          || isContext('s-arthistory')
          || isContext('s-cinema')
          || isContext('s-cognitive')
          || isContext('s-culturology')
          || isContext('s-mathematics')
          || isContext('s-media')
          || isContext('s-fashion')
          || isContext('s-music')
          || isContext('s-production')
          || isContext('s-pro')
          || isContext('s-hsetto')
          || isContext('s-psychology')
          || isContext('s-public-administration')
          || isContext('s-physics')
          || isContext('s-chemistry')
          || isContext('s-economy')
          || isContext('hsespacecreative')
          || isContext('hsespacefilm')
          || isContext('s-urban-development')
          || isContext('s-computer-science-and-engineering')
          || isContext('s-international-relations')
          || isContext('s-management')
          || isContext('s-political-science')
          || isContext('s-advertising-and-pr')
          || isContext('s-software-engineering')
          || isContext('s-sociology')
          || isContext('s-philology')
          || isContext('s-philosophy')
          || isContext('s-jurisprudence')
          || isContext('hsecreativehub')
        )
      )) || (isApp('deziiign') && isContext('onlines')) || (isApp('deziiign') && isContext('school'))
    ),
    isHSEDesign: (): boolean => isApp('deziiign') && (isContext('hsedesign')
      || isContext('prohse')
      || isContext('lmshse')
      || isContext('hsehh')
      || isContext('hsecolors')
      || isContext('hsecreative')
      || isContext('damuseum')
      || isContext('hsestart')
      || isContext('exams')
      || isContext('hsespace')
      || (
        isContext('s-architect')
        || isContext('s-biology')
        || isContext('s-oriental')
        || isContext('s-geography')
        || isContext('s-history')
        || isContext('s-arthistory')
        || isContext('s-cinema')
        || isContext('s-cognitive')
        || isContext('s-culturology')
        || isContext('s-mathematics')
        || isContext('s-media')
        || isContext('s-fashion')
        || isContext('s-music')
        || isContext('s-production')
        || isContext('s-pro')
        || isContext('s-hsetto')
        || isContext('s-psychology')
        || isContext('s-public-administration')
        || isContext('s-physics')
        || isContext('s-chemistry')
        || isContext('s-economy')
        || isContext('hsespacecreative')
        || isContext('hsespacefilm')
        || isContext('s-urban-development')
        || isContext('s-computer-science-and-engineering')
        || isContext('s-international-relations')
        || isContext('s-management')
        || isContext('s-political-science')
        || isContext('s-advertising-and-pr')
        || isContext('s-software-engineering')
        || isContext('s-sociology')
        || isContext('s-philology')
        || isContext('s-philosophy')
        || isContext('s-jurisprudence')
        || isContext('hsecreativehub')
      )
    ),
    isOnlineHSEDesign: (): boolean => isApp('deziiign') && isContext('online'),
    isOnlines: (): boolean => isApp('deziiign') && isContext('onlines'),
    isMediiia: (): boolean => isApp('deziiign') && (isContext('mediiia')
      || isContext('lmsmediiia')
      || isContext('namesmediiia')
      || isContext('sciencemediiia')
      || isContext('iqmedia')
      || isContext('historymediiia')
      || isContext('transfermediiia')
      || isContext('creativemediiia')
      || isContext('sportmediiia')
      || isContext('profmediiia')
      || isContext('photomediiia')
      || isContext('cinemediiia')
      || isContext('aimediiia')
      || isContext('historymediiia')
      || isContext('sportmediiia')
      || isContext('eventmediiia')
      || isContext('musicmediiia')
      || isContext('storiesmediiia')
      || isContext('naturemediiia')
      || isContext('designmediiia')
      || isContext('artmediiia')
      || isContext('fashionmediiia')
      || isContext('foodmediiia')
      || isContext('automediiia')
      || isContext('iqmediiia')
      || isContext('booksmediiia')
      || isContext('conceptmediiia')
    ),
    isCGRAVE: (): boolean => isContext('cgrave'),
    isGreenAward: (): boolean => isContext('greenaward'),
    isAdcrDafesNet: (): boolean => isContext('adcrdafesnet'),
    isContinuumSite: (): boolean => isContext('continuumsite'),
    isGameDeziiign: (): boolean => isContext('game'),
    isIqMediiia: (): boolean => isContext('iqmedia'),
    isHseHH: (): boolean => isContext('hsehh'),
    isHseColors: (): boolean => isContext('hsecolors'),
    isHseAnimation: (): boolean => isContext('hseanimation'),
    isHseSpace: (): boolean => isApp('deziiign') && (isContext('hsespace') 
      || (
        isContext('s-architect')
        || isContext('s-biology')
        || isContext('s-oriental')
        || isContext('s-geography')
        || isContext('s-history')
        || isContext('s-arthistory')
        || isContext('s-cinema')
        || isContext('s-cognitive')
        || isContext('s-culturology')
        || isContext('s-mathematics')
        || isContext('s-media')
        || isContext('s-fashion')
        || isContext('s-music')
        || isContext('s-production')
        || isContext('s-pro')
        || isContext('s-hsetto')
        || isContext('s-psychology')
        || isContext('s-public-administration')
        || isContext('s-physics')
        || isContext('s-chemistry')
        || isContext('s-economy')
        || isContext('hsespacecreative')
        || isContext('hsespacefilm')
        || isContext('s-urban-development')
        || isContext('s-computer-science-and-engineering')
        || isContext('s-international-relations')
        || isContext('s-management')
        || isContext('s-political-science')
        || isContext('s-advertising-and-pr')
        || isContext('s-software-engineering')
        || isContext('s-sociology')
        || isContext('s-philology')
        || isContext('s-philosophy')
        || isContext('s-jurisprudence')
        || isContext('hsecreativehub')
      )
    ),
    isCreativeSpace: (): boolean => isApp('deziiign') && isContext('hsespacecreative'),
    isLectureMediiia: (): boolean => isApp('deziiign') && isContext('lmsmediiia'),
    isNamesMediiia: (): boolean => isApp('deziiign') && isContext('namesmediiia'),
    isScienceMediiia: (): boolean => isApp('deziiign') && isContext('sciencemediiia'),
    isSchool: (): boolean => isApp('deziiign') && isContext('school'),
    isGeoMain: (): boolean => isApp('geograffee') && isContext('main'),
    isGeoDafes: (): boolean => isApp('geograffee') && isContext('dafes'),
    isPortfolio365: (): boolean => isApp('deziiign') && isContext('awards'),
    isKiiidsArt: (): boolean => isApp('deziiign') && isContext('kiiids'),
    isAcademy: (): boolean => isApp('geograffee') && isContext('academy'),
    isCompetitionEducation: (): boolean => isContext('competition'),
    isResearch: (): boolean => isApp('deziiign') && isContext('research'),
    isBooksDeziiign: (): boolean => (isApp('deziiign') && isContext('books')),
    isBooksMain: (): boolean => (isApp('deziiign') && isContext('books')) || isContext('booksgallllery'),
    isBooksGallllery: (): boolean => isContext('booksgallllery'),
    isBooksMediiia: (): boolean => isContext('booksmediiia'),
    isBooks: (): boolean => (
      ((isApp('deziiign') && isContext('books')) || isContext('booksgallllery'))
      || window.location.pathname.startsWith('/books')
      || window.location.pathname.startsWith('/hsebooks')
    ),
    isBrnd: (): boolean => isApp('deziiign') && isContext('brnd'),

    // Контексты Gallllery
    isGalllleryMain: (): boolean => isApp('gallllery') && isContext('main'),
    isMediaclub: (): boolean => isApp('gallllery') && isContext('mediaclub'),
    isSuperPuper: (): boolean => isApp('deziiign') && isContext('superpuper'),
    isFashionDeziiign: (): boolean => isApp('deziiign') && isContext('fashion'),
    isProDeziiign: (): boolean => isApp('deziiign') && ( isContext('pro') || isContext('prohse') || isContext('lmsmediiia')),
    isProHSE: (): boolean => isApp('deziiign') && isContext('prohse'),
    isLMSHSE: (): boolean => isApp('deziiign') && isContext('lmshse'),
    isLMSHSECreative: (): boolean => isApp('deziiign') && isContext('lmshsecreative'),
    isExamHSE: (): boolean => isApp('deziiign') && isContext('exams'),
    isDvaDesign: (): boolean => isApp('deziiign') && isContext('dvadesign'),
    isGalllleryArt: (): boolean => isApp('deziiign') && isContext('galllleryart'),
    isDaMuseum: (): boolean => isApp('deziiign') && isContext('damuseum'),
    isCreativeHSE: (): boolean => isApp('deziiign') && isContext('hsecreative'),
    isStartHSE: (): boolean => isApp('deziiign') && isContext('hsestart'),
    isLPUDesign: (): boolean => isApp('deziiign') && isContext('lpudesign'),
    isMonaLisaTravels: (): boolean => isApp('deziiign') && isContext('monalisatravels'),
  };
};

export type AppTesterType = ReturnType<typeof buildAppTester>;

export const AppTester: AppTesterType = buildAppTester(() => ApplicationShared.application);

export const isAnyOf = (): Record<string, boolean> => {
  return Object.entries(AppTester).slice(2).reduce((res, [key, callback]) => {
    return {
      ...res,
      [key]: callback(),
    }
  }, {} as Record<string, boolean>)
}
